import { AddCircle, CloudUpload, RemoveCircle } from "@mui/icons-material";
import { Box, Grid, IconButton, Paper, Typography } from "@mui/material";
import MUIDataTable from "mui-datatables";
import React, { useState } from "react";
import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import { addDoc, doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import saved from "../../assets/sound/saved.wav";
const ShoppingCart = (props) => {
  const { cartItems, onAdd, onRemove, location, data } = props;
  const [finalTotal, setFinalTotal] = useState(0);
  var countFinalTotal = 0;

  const current = new Date();
  const month = `${current.getMonth() + 1}`;
  const m = month < 10 ? "0" + month : month;
  const year = `${current.getFullYear()}`;
  const todayDate = "d" + year + m;
  const columns = [
    {
      name: "0", // 0
      label: "id",
      options: {
        display: false,
      },
    },
    {
      name: "1", // 1
      label: "Title",
    },
    {
      name: "2", // 1
      label: "Price",
    },
    {
      name: "qty", // 2
      label: "qt",
    },
    {
      name: "-",
      label: "Actions",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const rowId = tableMeta.rowData;
          return (
            <>
              <IconButton
                variant="contained"
                color="primary"
                onClick={(event) => {
                  onAdd(rowId);
                }}
              >
                <AddCircle />
              </IconButton>
              <IconButton
                variant="contained"
                color="error"
                onClick={(event) => {
                  onRemove(rowId);
                }}
              >
                <RemoveCircle />
              </IconButton>
            </>
          );
        },
      },
    },
  ];

  const options = {
    selectableRowsHideCheckboxes: true,
    sortOrder: {
      name: "title",
      direction: "asc",
    },
  };

  const handleUpdateData = () => {
    for (let i = 0; i < cartItems.length; i++) {
      var docId = cartItems[i][0];
      var qty = Number(cartItems[i].qty);
      updateProducts(docId, qty, location);
    }
  };
  const updateProducts = async (id, qty, location) => {
    const userDoc = doc(db, "products", id);
    const exist = data.find((x) => x.id === id);
    exist ? console.log("existe") : console.log("no");
    var store = Number(exist.stock_store);
    var van = Number(exist.stock_van);
    var web = Number(exist.stock_var1);
    var amazon = Number(exist.stock_var2);
    var price = Number(exist.price);
    countFinalTotal = countFinalTotal + price * qty;
    var newFields = {};
    if (location === "store") {
      store = store - qty;
    }
    if (location === "van") {
      van = van - qty;
    }
    if (location === "web") {
      web = web - qty;
    }
    if (location === "amazon") {
      amazon = amazon - qty;
    }
    var countTotal = store + van + web + amazon;

    if (location === "store") {
      newFields = { stock_store: store, stock_all: countTotal };
      await updateDoc(userDoc, newFields);
    }
    if (location === "van") {
      newFields = { stock_van: van, stock_all: countTotal };
      await updateDoc(userDoc, newFields);
    }
    if (location === "web") {
      newFields = { stock_var1: web, stock_all: countTotal };
      await updateDoc(userDoc, newFields);
    }
    if (location === "amazon") {
      newFields = { stock_var2: amazon, stock_all: countTotal };
      await updateDoc(userDoc, newFields);
    }
    setFinalTotal(countFinalTotal);
    // product stat  **************************
    //const docRef = doc(db, "productStat");
    const docRefId = doc(db, "productStat", id);
    const docSnap = await getDoc(docRefId);

    if (docSnap.exists()) {
      const dd = docSnap.data()[todayDate];
      newFields = { [todayDate]: qty + dd };
      await updateDoc(docRefId, newFields);
    } else {
      // const data = await addDoc(docRefId, {
      //   [todayDate]: qty,
      // });

      await setDoc(doc(db, "productStat", id), {
        [todayDate]: qty,
      });
    }
    //******************************* */
    new Audio(saved).play();
  };

  // const productStat = async (docId, qty) => {
  //   console.log("wtf");
  //   new Audio(saved).play();
  //   const docRef = doc(db, "productStat", docId);
  //   const docSnap = await getDoc(docRef);

  //   if (docSnap.exists()) {
  //     const dd = docSnap.data()[todayDate];
  //     console.log("Document data:", dd);
  //     console.log(dd + qty);
  //     console.log(todayDate);
  //   } else {
  //     // docSnap.data() will be undefined in this case
  //     console.log("No such document!");
  //   }
  // };

  return (
    <div>
      <Grid>
        <Paper>
          {cartItems.length === 0 && (
            <div>
              <Typography>.</Typography>
              <ProductionQuantityLimitsIcon
                sx={{
                  color: "gray",
                  width: 100,
                  height: 100,
                }}
              />
              <Typography variant="h6" sx={{ color: "secondary" }}>
                Cart is empty
              </Typography>
            </div>
          )}
          {cartItems.length !== 0 && (
            <MUIDataTable
              title="Cart"
              columns={columns}
              options={options}
              data={cartItems}
            />
          )}
        </Paper>
      </Grid>
      {cartItems.length !== 0 && (
        <Paper elevation={3} sx={{ paddingTop: "25px", gap: 2 }}>
          <div className="row">
            <div className="col-2 text-left">
              <strong>{location.toUpperCase()} Total Voucher </strong>
            </div>
            <div className="col-1 text-right">
              {finalTotal === 0 ? (
                ""
              ) : (
                <Typography variant="h3">${finalTotal}</Typography>
              )}
            </div>
          </div>

          {finalTotal !== 0 ? (
            ""
          ) : (
            <Box>
              <IconButton
                color="warning"
                onClick={handleUpdateData}
                aria-label="Save to Firestore"
              >
                <CloudUpload sx={{ width: "40px", height: "40px" }} />
              </IconButton>
            </Box>
          )}
        </Paper>
      )}
    </div>
  );
};

export default ShoppingCart;
